module.exports = __webpack_public_path__ + "static/media/genuine-background-TL.85e313c1.png";